import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  position: fixed;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
  height: 300px;
  width: 400px;
`;

export const Textarea = styled.textarea`
  width: 100%;
  height: 300px;
  padding: 10px;
  margin: 10px 0;
`;
